import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useGetSingleTransactionQuery } from "../../store";
import { MessageBox, MotionDiv, ViewCard } from "../../components";
import { Button, Card, Col, Row } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";

const keyProps = {
    Id: "id",
    Amount: "amount",
    Status: "status",
    "Payment Method": "payment_method",
    "Created At": "created_at",
    "Updated At": "updated_at",
    // Location: "location",
};

const ViewTransaction = () => {
    const { id } = useParams();

    const [modalShow, setModalShow] = useState(false);
    const { isLoading, isSuccess, error, data, isFetching, isError } = useGetSingleTransactionQuery(id);
    console.log(data);
    return (
        <>

            <ViewCard
                title={"Transaction Details"}
                data={data?.transaction}
                setModalShow={setModalShow}
                keyProps={keyProps}
                isImage={false}
                reducerProps={{ error, isLoading, isSuccess, isFetching }}
                showEdit={false}
            >
                {data?.transaction.status === "Completed" ?
                    <MotionDiv>
                        {isError ? (
                            <MessageBox variant="danger">
                                {error?.data?.error?.message}
                            </MessageBox>
                        ) : (
                            <Card.Body className="my-3">
                                <Row className="mb-4">
                                    <Card.Header className="d-flex align-items-center mb-4">
                                        <Card.Title>Payment Details</Card.Title>
                                    </Card.Header>
                                    <Row>
                                        <Col md={3}>
                                            <p className="mb-0">
                                                <strong>Payment Id</strong>
                                            </p>
                                            <p>
                                                {isFetching ? (
                                                    <Skeleton />
                                                ) : (
                                                    data.transaction.payment_id || "N/A"
                                                )}
                                            </p>
                                        </Col>
                                        <Col md={3}>
                                            <p className="mb-0">
                                                <strong>Card Brand</strong>
                                            </p>
                                            <p style={{ textTransform: 'capitalize' }}>
                                                {isFetching ? (
                                                    <Skeleton />
                                                ) : (
                                                    data.transaction.card_details.brand
                                                )}
                                            </p>
                                        </Col>
                                        <Col md={3}>
                                            <p className="mb-0">
                                                <strong>Card Type</strong>
                                            </p>
                                            <p style={{ textTransform: 'capitalize' }}>
                                                {isFetching ? (
                                                    <Skeleton />
                                                ) : (
                                                    data.transaction.card_details.type
                                                )}
                                            </p>
                                        </Col>
                                        <Col md={3}>
                                            <p className="mb-0">
                                                <strong>Last 4 Digits</strong>
                                            </p>
                                            <p>
                                                {isFetching ? (
                                                    <Skeleton />
                                                ) : (
                                                    data.transaction.card_details.last4
                                                )}
                                            </p>
                                        </Col>
                                    </Row>
                                </Row>
                                {/* <Row>
                                    <Col md={3}>
                                        <p>
                                            {isFetching ? (
                                                <Skeleton />
                                            ) : (
                                                <Button>
                                                    <a target="_blank" rel="noopener noreferrer" href={data.transaction.invoice}></a>
                                                    Download Invoice
                                                </Button>

                                            )}
                                        </p>
                                    </Col>
                                </Row> */}
                            </Card.Body>
                        )}
                    </MotionDiv>
                    :
                    <></>
                }
            </ViewCard>
        </>
    );
};

export default ViewTransaction;
